<template>
  <transition-group id="scale-grid" name="scale-grid" tag="div" class="scale-grid tiles flex flex-row flex-wrap items-start">
    <slot v-bind="{ size, full }"></slot>
  </transition-group>
</template>

<script>
export default {
  name: 'ScaleGrid',

  data() {
    return {
      size: 3,
      baseSize: 3,
      full: false,
    };
  },

  watch: {
    '$store.state.scale': function() {
      this.calcSize(this.$store.state.scale);
    },
    '$store.state.screenSize': function(v) {
      if (!this.responsive(v) && this.$route.name === 'partners') {
        this.size = this.size * 2;
      }
    },
    $route: function(to, from) {
      this.baseSize = to.name === 'partners' ? 6 : 3;
    },
  },

  methods: {
    responsive(v) {
      if (v === 1) {
        this.full = true;
        return false;
      }

      if (v === 2) {
        this.full = false;
        this.size = 2;
        return false;
      }

      this.calcSize(this.$store.state.scale);
      return true;
    },
    calcSize(percent) {
      this.size = this.baseSize + (100 - percent) / 20;
    },
  },

  created() {
    if (this.$route.name === 'partners') {
      this.baseSize = 6;
    }
    this.responsive(this.$store.state.screenSize);
  },
};
</script>
<style lang="scss">
.scale-grid {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
  position: relative;

  &.tiles {
    padding-bottom: calc(100vw - 2rem);

    @screen xs {
      padding-bottom: 200px;
    }
    @screen sm {
      padding-bottom: 0px;
    }
  }
}
.tile-container {
  display: inline-block;
  transition: all 0.5s ease-in-out;
}
.scale-grid-enter,
.scale-grid-leave-to {
  opacity: 0;
}
.scale-grid-leave-active {
  position: absolute;
  transform: translateX(-30%);
  &.full {
    width: calc(100% - 4rem);
  }
}
</style>
